import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-50e1363e")

_pushScopeId("data-v-50e1363e")
const _hoisted_1 = { class: "menu" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("ul", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList($setup.menuList, (menu, menuInd) => {
      return (_openBlock(), _createBlock("li", {
        key: menuInd,
        class: "menu__item"
      }, [
        _createVNode(_component_router_link, {
          class: "link menu__link",
          "active-class": "active",
          to: menu.to,
          exact: "",
          onClick: _cache[1] || (_cache[1] = $event => (_ctx.$emit('change-route')))
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t(menu.i18n)), 1 /* TEXT */)
          ]),
          _: 2
        }, 1032, ["to"])
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
})